export default "__VITE_ASSET__DvBqb4Iz__"